export default __webpack_public_path__ + "static/media/bg_bottom_new.8ea19443.jpg";